import { grpcBaseUrl } from './config';

const { DashboardServicePromiseClient } = require('./proto/acompanha/dashboard/v1/dashboard_grpc_web_pb.js');
const { AuthServicePromiseClient } = require('./proto/acompanha/auth/v1/auth_grpc_web_pb.js');
const { AccountServicePromiseClient } = require('./proto/acompanha/account/v1/account_grpc_web_pb.js');
const { JobsServicePromiseClient } = require('./proto/acompanha/jobs/v1/jobs_grpc_web_pb.js');
const { PrintersServicePromiseClient } = require('./proto/acompanha/printers/v1/printers_grpc_web_pb.js');
const { FilamentsServicePromiseClient } = require('./proto/acompanha/filaments/v1/filaments_grpc_web_pb.js');
const { SalesChannelsServicePromiseClient } = require('./proto/acompanha/sales_channels/v1/sales_channels_grpc_web_pb.js');
const { PaymentFeesServicePromiseClient } = require('./proto/acompanha/payment_fees/v1/payment_fees_grpc_web_pb.js');
const { ProductsServicePromiseClient } = require('./proto/acompanha/products/v1/products_grpc_web_pb.js');
const { CustomersServicePromiseClient } = require('./proto/acompanha/customers/v1/customers_grpc_web_pb.js');
const { CheckoutsServicePromiseClient } = require('./proto/acompanha/checkouts/v1/checkouts_grpc_web_pb.js');
const { OrdersServicePromiseClient } = require('./proto/acompanha/orders/v1/orders_grpc_web_pb.js');
const { TransactionsServicePromiseClient } = require('./proto/acompanha/transactions/v1/transactions_grpc_web_pb.js');
const { PrinterMaintenancesServicePromiseClient } = require('./proto/acompanha/printer_maintenances/v1/printer_maintenances_grpc_web_pb.js');

const host = () => grpcBaseUrl();

let dashboard;
let auth;
let account;
let jobs;
let printers;
let filaments;
let salesChannels;
let paymentFees;
let products;
let customers;
let checkouts;
let orders;
let transactions;
let printerMaintenances;

export function dashboardClient() {
    if (!dashboard) {
        dashboard = new DashboardServicePromiseClient(host(), null, null);
    }
    return dashboard;
}

export function authClient() {
    if (!auth) {
        auth = new AuthServicePromiseClient(host(), null, null);
    }
    return auth;
}

export function accountClient() {
    if (!account) {
        account = new AccountServicePromiseClient(host(), null, null);
    }
    return account;
}

export function jobsClient() {
    if (!jobs) {
        jobs = new JobsServicePromiseClient(host(), null, null);
    }
    return jobs;
}

export function printersClient() {
    if (!printers) {
        printers = new PrintersServicePromiseClient(host(), null, null);
    }
    return printers;
}

export function filamentsClient() {
    if (!filaments) {
        filaments = new FilamentsServicePromiseClient(host(), null, null);
    }
    return filaments;
}

export function salesChannelsClient() {
    if (!salesChannels) {
        salesChannels = new SalesChannelsServicePromiseClient(host(), null, null);
    }
    return salesChannels;
}

export function paymentFeesClient() {
    if (!paymentFees) {
        paymentFees = new PaymentFeesServicePromiseClient(host(), null, null);
    }
    return paymentFees;
}

export function productsClient() {
    if (!products) {
        products = new ProductsServicePromiseClient(host(), null, null);
    }
    return products;
}

export function customersClient() {
    if (!customers) {
        customers = new CustomersServicePromiseClient(host(), null, null);
    }
    return customers;
}

export function checkoutsClient() {
    if (!checkouts) {
        checkouts = new CheckoutsServicePromiseClient(host(), null, null);
    }
    return checkouts;
}

export function ordersClient() {
    if (!orders) {
        orders = new OrdersServicePromiseClient(host(), null, null);
    }
    return orders;
}

export function transactionsClient() {
    if (!transactions) {
        transactions = new TransactionsServicePromiseClient(host(), null, null);
    }
    return transactions;
}

export function printerMaintenancesClient() {
    if (!printerMaintenances) {
        printerMaintenances = new PrinterMaintenancesServicePromiseClient(host(), null, null);
    }
    return printerMaintenances;
}
